<div class="text-center mb-2" *ngIf="subscriptionGrouping">
  <a [routerLink]="['/batch/grouping/quiz/new',server_subscription_grouping_id,'standard']" class="btn btn-primary mx-1"><i class="fa fa-edit"></i> New Standard Quiz</a>
  <a [routerLink]="['/batch/grouping/quiz/new',server_subscription_grouping_id,'trivial']" class="btn btn-primary mx-1"><i class="fa fa-edit"></i> New Trivial Quiz</a>
  <a [routerLink]="['/grouping/quiz/subtopics/modify']" class="btn btn-primary mx-1"><i class="fa fa-edit"></i> Change Quiz Area</a>
  <a *ngIf="server_subscription_grouping_id"
  [routerLink]="['/batch/grouping/show',server_subscription_grouping_id]" class="btn btn-primary mx-1"><i class="fa fa-list"></i> Student List</a>
</div>

